export const testSelectedCard = {
  'lastFourDigits': 1234,
  'Name': 'Maria Contreras',
  'isExpired': false,
  'paymentTypeDescription': 'Visa'
};
